import { NoteType } from '@/@types/note';

export const NOTE_TYPES = [
  'OUTPUT',
  'ENTRY',
  'CASH_SESSION',
  'ROUTE_MANIFEST',
  'CUSTOMER',
  'VENDOR',
] as const satisfies readonly NoteType[];

export const NOTE_TYPE_LABELS: Record<NoteType, string> = {
  OUTPUT: 'SAÍDA',
  ENTRY: 'ENTRADA',
  CASH_SESSION: 'CAIXA',
  ROUTE_MANIFEST: 'ROMANEIO',
  CUSTOMER: 'CLIENTE',
  VENDOR: 'FORNECEDOR',
};
